import { useQuery } from '@tanstack/react-query'
import subscriptionApi from '../api/subscription'
import { useAuthStore } from '../store/authStore.js'

const useSubscriptionLimits = () => {
    const user = useAuthStore(s => s.user);
    const { data, isLoading, isError, error, refetch } = useQuery({
        queryKey: ['subscription-limits'],
        queryFn: async () => {
            const res = await subscriptionApi.getSubscriptionLimits()
            return res.data
        },
        enabled: !!user
    })
    return { data, isLoading, isError, error, refetch }
}

export default useSubscriptionLimits